/**
 * Errori tipizzati per build/download del pacchetto ZIP offline.
 */
export class CrashPackageZipError extends Error {
  /**
   * @param {'EMPTY' | 'ORG_MISSING' | 'ORG_MIXED' | 'USER_MISSING'} code
   * @param {string} message
   */
  constructor(code, message) {
    super(message)
    this.name = 'CrashPackageZipError'
    this.code = code
  }
}
